var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZoomOutHorizontal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4401 16.8179H17.7174L17.4613 16.5709C18.3578 15.528 18.8975 14.1741 18.8975 12.7013C18.8975 9.41712 16.2354 6.75503 12.9513 6.75503C9.66709 6.75503 7.005 9.41712 7.005 12.7013C7.005 15.9854 9.66709 18.6475 12.9513 18.6475C14.4241 18.6475 15.778 18.1078 16.8209 17.2113L17.0679 17.4674V18.1901L21.6419 22.755L23.005 21.392L18.4401 16.8179ZM12.9513 16.8179C10.6734 16.8179 8.83462 14.9792 8.83462 12.7013C8.83462 10.4234 10.6734 8.58465 12.9513 8.58465C15.2291 8.58465 17.0679 10.4234 17.0679 12.7013C17.0679 14.9792 15.2291 16.8179 12.9513 16.8179ZM10.6642 12.2439H15.2383V13.1587H10.6642V12.2439Z",
    fill: "#1953B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 4.50003L7.75 7.38678V1.61328L2.75 4.50003ZM22.75 4.50003L17.75 1.61328V7.38678L22.75 4.50003ZM7.25 5.00003H18.25V4.00003H7.25V5.00003Z",
    fill: "#1953B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZoomOutHorizontal);
export default __webpack_public_path__ + "static/media/zoomOutHorizontal.08f488267a08aee56c00b01c4d4875bb.svg";
export { ForwardRef as ReactComponent };